import { type ReactElement } from 'react';

interface HeaderProperties {
  readonly sortedVehiclesCount: number;
}

const Header = ({ sortedVehiclesCount }: HeaderProperties): ReactElement => (
  <div>
    <div className="tds-detail-03 tds-text-grey-350">
      {sortedVehiclesCount} VEHICLE{sortedVehiclesCount === 1 ? '' : 'S'}
    </div>
  </div>
);

export default Header;
